export default "__VITE_ASSET__DUXkplEI__"